exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DetailsContainer .layout-pane>*{box-sizing:border-box;width:100%;height:100%}.DetailsContainer .layout-pane:not(.layout-pane-primary){max-width:250px}.DetailsContainer{position:unset}.DetailsContainer .layout-splitter{background:var(--grey-10);border-left:1px solid var(--grey-30);border-top:1px solid var(--grey-30)}.DetailsContainer .layout-splitter:hover{background:var(--grey-30)}", ""]);

// exports
